"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var VertThreeDots = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(VertThreeDots, _Component);

  var _super = _createSuper(VertThreeDots);

  function VertThreeDots() {
    (0, _classCallCheck2["default"])(this, VertThreeDots);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(VertThreeDots, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base["default"], this.props, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "28",
        y: "44",
        width: "8",
        height: "8"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "28",
        y: "28",
        width: "8",
        height: "8"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "28",
        y: "12",
        width: "8",
        height: "8"
      }));
    }
  }]);
  return VertThreeDots;
}(_react.Component);

exports["default"] = VertThreeDots;
(0, _defineProperty2["default"])(VertThreeDots, "defaultProps", {
  height: '16px',
  predefinedClassName: 'data-ex-icons-vert-three-dots'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vaWNvbnMvdmVydC10aHJlZS1kb3RzLnRzeCJdLCJuYW1lcyI6WyJWZXJ0VGhyZWVEb3RzIiwicHJvcHMiLCJDb21wb25lbnQiLCJoZWlnaHQiLCJwcmVkZWZpbmVkQ2xhc3NOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7SUFFcUJBLGE7Ozs7Ozs7Ozs7OztXQU1uQixrQkFBUztBQUNQLDBCQUNFLGdDQUFDLGdCQUFELEVBQVUsS0FBS0MsS0FBZixlQUNFO0FBQU0sUUFBQSxDQUFDLEVBQUMsSUFBUjtBQUFhLFFBQUEsQ0FBQyxFQUFDLElBQWY7QUFBb0IsUUFBQSxLQUFLLEVBQUMsR0FBMUI7QUFBOEIsUUFBQSxNQUFNLEVBQUM7QUFBckMsUUFERixlQUVFO0FBQU0sUUFBQSxDQUFDLEVBQUMsSUFBUjtBQUFhLFFBQUEsQ0FBQyxFQUFDLElBQWY7QUFBb0IsUUFBQSxLQUFLLEVBQUMsR0FBMUI7QUFBOEIsUUFBQSxNQUFNLEVBQUM7QUFBckMsUUFGRixlQUdFO0FBQU0sUUFBQSxDQUFDLEVBQUMsSUFBUjtBQUFhLFFBQUEsQ0FBQyxFQUFDLElBQWY7QUFBb0IsUUFBQSxLQUFLLEVBQUMsR0FBMUI7QUFBOEIsUUFBQSxNQUFNLEVBQUM7QUFBckMsUUFIRixDQURGO0FBT0Q7OztFQWR3Q0MsZ0I7OztpQ0FBdEJGLGEsa0JBQ0c7QUFDcEJHLEVBQUFBLE1BQU0sRUFBRSxNQURZO0FBRXBCQyxFQUFBQSxtQkFBbUIsRUFBRTtBQUZELEMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTUERYLUxpY2Vuc2UtSWRlbnRpZmllcjogTUlUXG4vLyBDb3B5cmlnaHQgY29udHJpYnV0b3JzIHRvIHRoZSBrZXBsZXIuZ2wgcHJvamVjdFxuXG5pbXBvcnQgUmVhY3QsIHtDb21wb25lbnR9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBCYXNlLCB7QmFzZVByb3BzfSBmcm9tICcuL2Jhc2UnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBWZXJ0VGhyZWVEb3RzIGV4dGVuZHMgQ29tcG9uZW50PFBhcnRpYWw8QmFzZVByb3BzPj4ge1xuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIGhlaWdodDogJzE2cHgnLFxuICAgIHByZWRlZmluZWRDbGFzc05hbWU6ICdkYXRhLWV4LWljb25zLXZlcnQtdGhyZWUtZG90cydcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxCYXNlIHsuLi50aGlzLnByb3BzfT5cbiAgICAgICAgPHJlY3QgeD1cIjI4XCIgeT1cIjQ0XCIgd2lkdGg9XCI4XCIgaGVpZ2h0PVwiOFwiIC8+XG4gICAgICAgIDxyZWN0IHg9XCIyOFwiIHk9XCIyOFwiIHdpZHRoPVwiOFwiIGhlaWdodD1cIjhcIiAvPlxuICAgICAgICA8cmVjdCB4PVwiMjhcIiB5PVwiMTJcIiB3aWR0aD1cIjhcIiBoZWlnaHQ9XCI4XCIgLz5cbiAgICAgIDwvQmFzZT5cbiAgICApO1xuICB9XG59XG4iXX0=